"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const material_1 = require("@mui/material");
const types_1 = require("@framework/types");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const utils_1 = require("../../utils");
const DurationInput = (props) => {
    const { readOnly = false } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const durationAmount = (0, react_hook_form_1.useWatch)({ name: "durationAmount" });
    const durationUnit = (0, react_hook_form_1.useWatch)({ name: "durationUnit" });
    const normalizeValue = (0, react_1.useCallback)((durationAmount) => {
        return (0, utils_1.normalizeDuration)({ durationAmount, durationUnit });
    }, [durationUnit]);
    const formatValue = (0, react_1.useCallback)((durationAmount) => {
        return (0, utils_1.formatDuration)({ durationAmount, durationUnit });
    }, [durationUnit]);
    // memoize value to handle changing durationUnit
    // and setting correct value to the form according to the new durationUnit
    const memoizedValue = (0, react_1.useMemo)(() => normalizeValue(durationAmount), [durationAmount]);
    (0, react_1.useEffect)(() => {
        form.setValue("durationAmount", formatValue(memoizedValue), { shouldTouch: true });
    }, [durationUnit]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", gap: 1, children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.NumberInput, { name: "durationAmount", normalizeValue: normalizeValue, formatValue: formatValue, onBlur: () => {
                    return;
                }, type: "number", readOnly: readOnly, endAdornment: null }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "durationUnit", options: types_1.DurationUnit, readOnly: readOnly })] }));
};
exports.DurationInput = DurationInput;
//# sourceMappingURL=index.js.map